export default __webpack_public_path__ + "static/media/gallery-wip-crystal-chamber_03.4ea06535.jpg";